import React, {Component} from 'react'
import PropType from 'prop-types'
import WorkerStatistics from "./WorkerStatistics"

class ChooseDevices extends Component {
    state = {
        current: 'd1'
    }

    _handleChangeDevice = e => {
        const {value} = e.target

        this.setState({
            current: value
        })

        this.props.onChange(value)
    }

    render() {
        return (
            <div className="ChooseDevices col-md-4 col-12">
                <label>Choose devices</label>

                <div className="form-group">
                    <select
                        className="form-control"
                        onChange={this._handleChangeDevice} value={this.state.current}>
                        {/*<option value="">Computer</option>*/}
                        <option value="d1">Computer 1</option>
                        {/*<option value="d2">Computer 2 - 1 055 917 537</option>*/}
                        {/*<option value="d3">Computer 3 - 344 648 255</option>*/}
                        {/*<option value="d4">Computer 4</option>*/}
                    </select>
                </div>

                <WorkerStatistics/>
            </div>
        )
    }
}

ChooseDevices.propTypes = {
    onChange: PropType.func.isRequired,
}

export default ChooseDevices



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/workers/components/ChooseDevices.js